import { Component } from '@angular/core';

@Component({
  selector: 'page-about-ionic',
  templateUrl: 'about-ionic.html'
})
export class AboutIonicPage {
  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts